import React, { FunctionComponent } from 'react';
import { CheckupTag } from '@companion-professional/dctypes';
import { cn, snakeToSentenceCase } from '@companion-professional/webutils';
import { Badge } from '@companion-professional/components';
import { defaultTagBadge, tagBadgeDisplay } from './tagBadgeDisplay';

interface TagBadgesProps {
  tags: CheckupTag[];

  // tagsToShow is an optional prop that can be used to filter the tags that are displayed.  If it is not provided, all
  // tags will be displayed.  Passing an empty array will result in no tags being displayed.
  tagsToShow?: CheckupTag[];

  // showLabel is an optional prop that can be used to show the label for the tag.  Defaults to false.
  showLabel?: boolean;
}

// TagBadges displays a list of tags as badges (colored pills with icons).  It will display a custom icon and Badge
// variant for each tag if an entry exists in the tagBadgeDisplay mapping.  Otherwise, it will use the defaultTagBadge
// icon and variant.
export const TagBadges: FunctionComponent<TagBadgesProps> = ({ tags, tagsToShow, showLabel }) => {
  return (
    <div className="flex justify-center">
      {tags
        .filter((tag) => !tagsToShow || tagsToShow.includes(tag))
        .map((tag) => {
          let { variant, icon: TagIcon } = defaultTagBadge;

          // If we have a variant and icon for the tag, use it.
          if (Object.keys(tagBadgeDisplay).includes(tag) && tagBadgeDisplay[tag]) {
            variant = tagBadgeDisplay[tag].variant;
            TagIcon = tagBadgeDisplay[tag].icon;
          }

          return (
            <Badge
              key={tag}
              variant={variant}
              className={cn('mr-1 gap-1', {
                'justify-start text-nowrap px-2 py-1': showLabel,
                'p-1': !showLabel
              })}
            >
              <TagIcon className="h-4 w-4" />
              {showLabel ? <span>{snakeToSentenceCase(tag)}</span> : null}
            </Badge>
          );
        })}
    </div>
  );
};
